import BaseResource from './base-resource';
import GroupResource from './group-resource';
import JsonApiResource from './jsonapi-resource';
import ReferenceResolver from './reference-resolver';
import RoleResource from './role-resource';
import SiteResource from './site-resource';

export default class UserRoleResource extends BaseResource {
  model: string = null;
  action: string = null;
  group: GroupResource = new SiteResource();
  role: RoleResource = new RoleResource();

  attributes = {
    model: '<',
    action: '<'
  };

  constructor(init?: Partial<UserRoleResource>) {
    super(init, 'user-roles');
    this.initialize(init);
  }
}



// WEBPACK FOOTER //
// ./common/models/user-role-resource.ts